import React from "react";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import { Toast } from 'primereact/toast';

import TextInput from "../../../../../Components/TextInput";
import FileInput from "../../../../../Components/FileInput";

interface TenderDocumentModalProps {
    isOpen: boolean;
    dataState: 'Add' | 'Edit';
    onClose: () => void;
    toast: React.RefObject<Toast>;
    serviceName?: string;
    documentName: string;
    setDocumentName: React.Dispatch<React.SetStateAction<string>>;
    uploadedFileName: string;
    handleFileUpload: (file: File) => void;
    handleCreateDocument: (e: React.FormEvent) => void;
    handleUpdateDocument?: (e: React.FormEvent) => void;
    handleClearFile?: () => void;
    loading: boolean;
    documentNameError?: string;
    fileError?: string;
    isDocumentNameRequired?: boolean;
    isFileRequired?: boolean;
}

const TenderDocumentModal: React.FC<TenderDocumentModalProps> = ({
    isOpen,
    dataState,
    onClose,
    toast,
    serviceName,
    documentName,
    setDocumentName,
    uploadedFileName,
    handleFileUpload,
    handleCreateDocument,
    handleUpdateDocument,
    handleClearFile,
    loading,
    documentNameError,
    fileError,
    isDocumentNameRequired,
    isFileRequired
}) => {

    /* Modal header */
    const documentModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Add ' : 'Edit '} {serviceName}&nbsp;document
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={onClose}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const documentModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Cancel" className="custom_btn secondary" onClick={onClose} />
            <Button label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreateDocument : handleUpdateDocument}
                loading={loading} className="custom_btn primary" />
        </div>
    );

    return (
        <Dialog
            visible={isOpen}
            header={documentModalHeader}
            footer={documentModalFooter}
            headerClassName="custom_modal_header"
            className="custom_modal_dialog modal_dialog_sm"
            onHide={onClose}
            dismissableMask>
            <div className="custom_modal_body">
            <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                    <div className="row">
                        <div className="col-12">
                            <TextInput
                                id="documentName"
                                label="Document name"
                                labelHtmlFor="documentName"
                                required={isDocumentNameRequired}
                                value={documentName}
                                placeholder="Document name"
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDocumentName(e.target.value)}
                                error={documentNameError}
                            />
                        </div>

                        <div className="col-12">
                            <FileInput
                                id="uploadedFile"
                                label="Upload file"
                                labelHtmlFor="uploadedFile"
                                required={isFileRequired}
                                value={uploadedFileName}
                                onUpload={handleFileUpload}
                                onClear={handleClearFile}
                                toast={toast}
                                error={fileError}
                                containerClassName="mb-0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    )
}

export default TenderDocumentModal;